// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__k0Pcb","label":"Labeled_label__3rH3M","divider":"Labeled_divider__3VygI"};